<template>
  <div>
    <router-view class="con_view"></router-view>
    <footer>
      <ul>
        <router-link v-for="(item,index) in footerData"
                     :key="index"
                     :to="item.urls">
          <li>
            <div class="fontWrap"
                 v-html="item.icon"></div>
            <span :style="{color:routerName=='Allvideo'&&item.name=='视频'?'#007EFF':''}">{{item.name}}</span>
          </li>
        </router-link>

      </ul>
    </footer>

  </div>
</template>
<script>


import weui from "weui.js";
export default {
  data () {
    return {
      footerData: [
        { name: "视频", icon: '<i class="iconfont">&#xe60b;</i>', urls: "/index/video", desc: "Video" },
        { name: "直播", icon: '<i class="iconfont">&#xe61f;</i>', urls: "/index/live", desc: "Live" },
        { name: "专栏", icon: '<i class="iconfont">&#xe761;</i>', urls: "/index/column", desc: "Column" },
        { name: "我的", icon: '<i class="iconfont">&#xe600;</i>', urls: "/index/me", desc: "Me" }
      ]
    }
  },
  props: {},
  methods: {
    toJump (url) {
      this.$router.push({
        path: url,
      })
    },
  },
  computed: {
    routerName () {
      return this.$route.name

    }
  },
  mounted () {

  }
}
</script>
<style scoped lang="scss">
.con_view {
  overflow: hidden;
  background: #ffffff;
  /*margin-bottom: 0.98rem;*/
}
footer {
  width: 100%;
  position: fixed;
  bottom: 0px;
  margin-top: 0.98rem;
  border-top: 1px solid #e6e6e6;
  background: #ffffff;
  z-index: 3;

  ul {
    width: 7.5rem;
    height: 0.98rem;

    display: flex;
    justify-content: center;
    align-items: center;
    background: #ffffff;
    a {
      // float:left;
      width: 25%;
      text-decoration: none;
      background: #ffffff;
      display: inline-block;
      // width: 100%;
    }
    li {
      // float:left;
      // width: 25%;
      margin: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 0.16rem;
      color: #666666;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue